export const SESSION_DIALOG_IDS = {
    anniversaryPromo: 'anniversary-promo',
    oldUsersPromo: 'old-users-promo',
    converterPromo: 'converter-promo-dialog',
    creatorProfileOffer: 'creator-profile-offer',
} as const

export type TSessionDialogId = (typeof SESSION_DIALOG_IDS)[keyof typeof SESSION_DIALOG_IDS]

export const OLD_USERS_MIN_VISITS = 2

export const ANNIVERSARY_DAYS_THRESHOLD = 30
